import { EXTRACT_SINDICATO_FORCE_MOCK } from "./extractSindicatoMock";

const MockModeBanner = () => {
  if (!EXTRACT_SINDICATO_FORCE_MOCK) return null;

  return (
    <div className="extract-sindicato-mock-banner" role="status">
      Modo demonstração ativo — dados mockados (
      <code>REACT_APP_EXTRACT_SINDICATO_FORCE_MOCK=true</code>)
    </div>
  );
};

export default MockModeBanner;
